module.exports = __webpack_public_path__ + "img/logo_preto.fc055277.png";